import React, { useState, useEffect, useContext } from "react";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import RegisterModal from "../../../../common-section/Modals/RegisterModal/RegisterModal"
import { vendorRegister } from "../../../../../utils/apis/form/form";
import { useNavigate } from "react-router-dom";
import Success_modal from "../../../../common-section/Modals/Success_modal/Success_modal";

// import { RegxExpression } from "../../../../utils/common";

library.add(fas);

function Steptwo({ prevStep, nextStep, setStepData, savedData, allFormData }) {

  const navigate = useNavigate()

  const [fieldclick, setFieldclick] = useState(false);
  const handleFields = () => {
    setFieldclick(true);
  }

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const options = [
    { value: " XD", label: " XD" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const {
    control,
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: savedData || {}, // Initialize with saved data if available
  });

  const imageFile = watch("image");

  const [modalShow, setModalShow] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("file", file)
    clearErrors("logo");
  };


  const onSubmit = async (data) => {
    try {


      const finalData = new FormData();

      

      if(data?.agreement_policy){
        finalData.append("agreement_policy",1);
      }      

      if (data?.image && data.image.length > 0) {
        finalData.append("digital_signature", data.image[0]);
      }

      console.log("finalData", finalData)

      // Append stepOne and stepEight data to FormData
      Object.entries(allFormData?.stepOne || {}).forEach(([key, value]) => {
        if (typeof value === "object" && value !== null) {
          // Append the `value` property of the object if it exists
          finalData.append(key, value.value || ""); // Use `value.value` or fallback to an empty string
        } else {
          // Append primitive values directly
          finalData.append(key, value);
        }
      });

      Object.entries(allFormData?.stepEight || {}).forEach(([key, value]) => {
        if (typeof value === "object" && value !== null) {
          // Append the `value` property of the object if it exists
          finalData.append(key, value.value || ""); // Use `value.value` or fallback to an empty string
        } else {
          // Append primitive values directly
          finalData.append(key, value);
        }
      });

      for (let [key, value] of finalData.entries()) {
        console.log(`${key}:`, value);
      }

      const res = await vendorRegister(finalData)

      console.log("success", res)

      if (res?.success) {
        console.log("success", res?.success)
        setModalShow(true)
        setTimeout(() => {
          navigate("/")
        }, 3000);
      }

    } catch (error) {
      console.log(error);
    }
  };


  // const onSubmit = async (data) => {

  //   const finalData = new FormData();

  //   if (data?.digital_signature && data.digital_signature.length > 0) {
  //     finalData.append("digital_signature", data.digital_signature[0]);
  //   }

  //   finalData.append("agreement_policy", data?.agreement_policy);



  //   const stepThreeData = getValues();



  //   const processedStepThreeData = {
  //     ...stepThreeData,
  //     digital_signature: stepThreeData.digital_signature?.[0] // If not an array, keep it as is
  //   };



  //   const combineData = {
  //     ...allFormData?.stepOne,
  //     ...allFormData?.stepEight,
  //     ...finalData
  //   }



  //   console.log("combineData", combineData)

  //   const res = vendorRegister(combineData)

  //   if (res?.success) {
  //     setModalShow(true)
  //   }

  // };


  return (
    <>
      <div className="personal-details-form userForm">
        <h6>Agreement Policy</h6>

        <div className="agrrementdiv">
          <ol>
            <li>Agreement Overview
              <p>By using our services, you agree to these terms and conditions. This agreement is between the event organizer ("Client") and the event management company ("Company").
              </p>
            </li>
            <li>Services Provided
              <p>The Company will provide event planning and management services as outlined in the service agreement, including but not limited to venue booking, vendor coordination, and on-site management.</p>
            </li>
            <li>Payment Terms
              <p>Fees: The Client agrees to pay the agreed-upon service fees.
                Payment Schedule: Payments will be made according to the schedule in the service agreement.
                Late Payments: Late payments may incur additional fees.
              </p>
            </li>
            <li>Cancellation & Refunds
              <p>Client Cancellation: Cancellations must be made in writing. Refunds are subject to the terms specified in the service agreement.
                Company Cancellation: The Company reserves the right to cancel services in case of breach of agreement, with refunds made per agreement terms.
              </p>
            </li>
            <li>Liability
              <p>The Company is not responsible for any loss, damage, or injury during the event, except in cases of gross negligence.
              </p>
            </li>
            <li>Force Majeure
              <p>The Company is not liable for delays or cancellations due to unforeseen events such as natural disasters, pandemics, or government restrictions.</p>
            </li>
            <li>Vendor and Third-Party Services
              <p>The Company may recommend or engage third-party vendors, but is not liable for their performance or any issues arising from their services.
              </p>
            </li>


          </ol>
        </div>



        {/* form-holder */}

        <div className="details-form-holder">
          <div className="row">

            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="field-bottom">

                    <Form.Group className="form-group" controlId="digital_sign">
                      <Form.Label className="required">Upload Digital Signture</Form.Label>

                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          type="file"
                          {...register("image", {
                            required: "Image is required",
                            // validate: async (value) => {
                            //   if (typeof value !== "string") {
                            //     const fileTypes = ["jpg", "png", "jpeg"];
                            //     const fileType = value[0].name?.split(".")[1];

                            //     if (!fileTypes.includes(fileType)) {
                            //       return `please upload a valid file format. (${fileTypes})`;
                            //     }

                            //     const sizes = await getDimension(value[0]);
                            //     if (
                            //       sizes.width !== 1296 &&
                            //       sizes.height !== 465
                            //     ) {
                            //       return "Image width and height must be 1296 px and 465 px";
                            //     }
                            //   }
                            // },
                          })}
                          accept=".jpg, .jpeg, .png"
                        />
                      </Form.Group>
                      {errors.image && (
                        <span className="text-danger">
                          {errors.image.message}
                        </span>
                      )}








                      {/* <Form.Control
                        type="file"
                        name="digital_sign"
                        placeholder="Enter Certification"


                        id="digital_sign"
                        accept="image/*"
                        {...register("digital_sign", {
                          required: "Image is required",
                        })}
                        onChange={handleFileChange}

                      /> */}
                      {/* <img className="digising" src={process.env.PUBLIC_URL + '/assets/images/icons/digital.png'} /> */}
                    </Form.Group>
                  </div>
                </div>

                <div className="col-md-12">
                  <Form.Label>Image Preview</Form.Label>

                  {imageFile && imageFile?.length > 0 && (
                    <div className="image-preview-container mt-3">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )}
                </div>


                {['checkbox'].map((type) => {
                  return (
                    <div key={`default-${type}`} className="mb-3 mt-3">
                      <Form.Check
                        type={type}
                        id={`default-${type}`}
                        label="I agree to all the Agreement Policy."
                        className={classNames("", {
                          "is-invalid": errors.agreement_policy, // Use the correct field name
                        })}
                        name="agreement_policy"
                        {...register("agreement_policy", {
                          required: "You must agree to the Agreement Policy", // Validation rule
                        })}
                      />
                      {/* Display error message */}
                      {errors.agreement_policy && (
                        <p className="text-danger mt-3">
                          {errors.agreement_policy.message}
                        </p>
                      )}
                    </div>
                  );
                })}


                <div className="col-md-12">
                  <div className=" text-center apply_now_btn">


                    <Button onClick={prevStep} className="back-btn me-3">
                      Back
                    </Button>
                    <button className="tabs-btn btn" type="submit">Next</button>
                  </div>
                </div>

              </div>
            </Form>

            {/* <button  onClick={() => setModalShow(true)} type="button">Register</button> */}

          </div>
          {/* <RegisterModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            message="Successfully  Register as a vendor"
          /> */}

          <Success_modal
            maintext={"Successfully  Register as a vendor"}
            show={modalShow}
            onHide={() => setModalShow(false)}
          />

        </div>
      </div>


    </>
  );
}

export default Steptwo;
